import { render } from "./editTweet.vue?vue&type=template&id=647ce8e2"
const script = {}
script.render = render

export default script